<template>
  <div>
    <template v-if="mode !== 'nodate'">
      <table class="rangedata_table">
        <tr>
          <td style="vertical-align: middle">Dal</td>
          <td style="vertical-align: middle">&nbsp;</td>
          <td>
            <div v-if="mode === 'datetime'">
              <date-picker
                v-model="startData"
                type="datetime"
                value-type="YYYY-MM-DD HH:mm"
                format="DD-MM-YYYY HH:mm"
                confirm
              ></date-picker>
            </div>
            <div v-else>
              <date-picker
                v-model="startData"
                type="date"
                value-type="YYYY-MM-DD"
                format="DD-MM-YYYY"
                confirm
              ></date-picker>
            </div>
          </td>
        </tr>
        <tr>
          <td style="vertical-align: middle">Al</td>
          <td style="vertical-align: middle">&nbsp;</td>
          <td>
            <div v-if="mode === 'datetime'">
              <date-picker
                v-model="endData"
                type="datetime"
                value-type="YYYY-MM-DD HH:mm"
                format="DD-MM-YYYY HH:mm"
                confirm
              ></date-picker>
            </div>
            <div v-else>
              <date-picker
                v-model="endData"
                type="date"
                value-type="YYYY-MM-DD"
                format="DD-MM-YYYY"
                confirm
              ></date-picker>
            </div>
          </td>
        </tr>
      </table>
    </template>
    <div v-if="vehicleVis === true">
      <div v-if="itemSelected !== null" class="rangedata_box">
        Veicolo: {{ itemSelected.RegistrationPlate }}
      </div>
      <div v-else class="rangedata_box">Selezionare un veicolo</div>

      <div class="rangecontainer" id="rangecontainer" ref="rangecontainer">
        <div class="rangecontent" id="rangecontent" ref="rangecontent">
          <ul>
            <li
              v-for="item in vehicles"
              :key="item.cod"
              @click="selectItem(item)"
              :class="[
                itemSelected === item
                  ? 'is-item-selected'
                  : 'is-item-not-selected',
                'pl-1 pt-1 pb-1 pointer',
              ]"
            >
              <div class="columns">
                <div class="column is-narrow">
                  {{ item.RegistrationPlate }}
                </div>
                <div class="column">
                  {{ item.Producer }}&nbsp;{{ item.Model }}
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <section>
      <div class="pad_bottom has-text-centered" v-if="searchActive">
        <BUTTON
          class="button is-success buttonsize is-small"
          @click="goRangeDate($event)"
          >Apri</BUTTON
        >
      </div>
    </section>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
export default {
  name: 'RangeDate',
  components: {
    DatePicker,
  },
  mixins: [UtilityMixin],
  props: {
    sData: {
      default: null,
      type: String,
    },
    eData: {
      default: null,
      type: String,
    },
    mode: {
      default: null,
      type: String,
    },
    vehicleVis: {
      default: false,
      type: Boolean,
    },
    vehicles: {
      default: null,
      type: Array,
    },
    isLoading: {
      default: false,
      type: Boolean,
    },
    searchActive: {
      default: true,
      type: Boolean,
    },
    height: {
      default: 100,
      type: Number,
    },
  },
  data: function () {
    return {
      startData: '',
      endData: '',
      itemSelected: null,
    }
  },

  created() {
    const vm = this
    vm.startData = vm.sData
    vm.endData = vm.eData
  },
  watch: {
    height(newHeight, oldHeight) {
      const vm = this
      let aa = vm.height - 60
      vm.$refs.rangecontent.style.height = aa + 'px'
    },
    startData(newData, oldData) {
      const vm = this
      if (vm.endData.length > 0 && newData > vm.endData) {
        vm.$dialog
          .alert('Controllare le date inserite!')
          .then(function () {
            vm.startData = oldData
          })
          .catch(function () {})
      }
    },
    endData(newData, oldData) {
      const vm = this
      if (vm.startData.length > 0 && newData < vm.startData) {
        vm.$dialog
          .alert('Controlllare le date inserite!')
          .then(function () {
            vm.endData = oldData
          })
          .catch(function () {})
      }
    },
  },
  methods: {
    selectItem(item) {
      const vm = this
      vm.itemSelected = item
      ServiceBus.$emit('selectedRangeDate', item)
    },
    goRangeDate(e) {
      e.preventDefault()
      const vm = this
      let obj = {}
      if (vm.itemSelected !== null || !vm.vehicleVis) {
        obj.startData = vm.startData
        obj.endData = vm.endData
        obj.item = vm.itemSelected
        ServiceBus.$emit('setRangeDate', obj)
      } else {
        vm.$dialog
          .alert('Selezionare un veicolo!')
          .then(function () {})
          .catch(function () {})
      }
    },
  },
}
</script>
<style scoped>
.rangedata_table {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}
.rangedata_box {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  font-weight: 700;
  margin: 0 !important;
  padding: 10px;
  background-color: whitesmoke;
  width: 100%;
  border: 1px solid lightgray;
}

.rangecontainer {
  width: 270px;
  height: 580px;
  padding: 3px;
}

.rangecontent {
  overflow-y: auto;
  overflow-x: hidden;
  height: 500px;
}
</style>
